module.exports = __webpack_public_path__ + "static/media/milford-sounds.557bd502.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photography/milford-sounds.jpg
// module id = 140
// module chunks = 0